import request from './request';
import {Iprofile} from 'model/profile';

export const getUserProfile = () =>
  request.request<Iprofile>({
    url: '/auth/profile/',
    method: 'GET',
  });
